import { AfterViewInit, Component, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../../global.variable';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { AddEditSubContractor } from './add-edit-sub-contractor/add-edit-sub-contractor';
import { SubContactorsService } from './sub-contactors.service';

@Component({
  selector: 'gtapp-sub-contractors',
  standalone: false,
  templateUrl: './sub-contractors.component.html',
  styleUrl: './sub-contractors.component.scss',
})
export class SubContractorsComponent implements AfterViewInit {
  contactorsListData: any = [];
  totalCountContractors: number = 0;
  previousContractors: number = 0;
  rowsContractors: number = 10;
  pageNumContractors: number = 1;
  totalPagesContractors: number = 0;
  sortKeyContractors: any;
  searchParamsContractors: any;
  otherParamsContractors: any = {};

  contactorTableDetails: any = [];

  tableStyle = {
    'overflow': 'auto',
    'max-height': '100%',
  };
  selectedContractor: any = {};
  largeView: Boolean = isLargeScreen;

  constructor(
    private contractorService: SubContactorsService,
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute,
  ) {
    this.formatRouteUrl();
    this.getTableDetails();
  }

  ngAfterViewInit(): void {
    this.spinnerService.show();
    this.getSubContractors();
  }
  openAddTemplate() {
    const dialogRef = this.dialogService.open(
      AddEditSubContractor,
      {},
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) this.getSubContractors(true);
    });
  }

  getContractorsCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.contractorService.getContactors(params).then((response: any) => {
      if (response['status'] == 'success') {
        this.otherParamsContractors = {
          ...this.otherParamsContractors,
          paginationData: {
            totalRows: response?.total_count,
            previousRows: this.previousContractors,
            rows: this.rowsContractors,
            pageNum: this.pageNumContractors,
            totalPages: this.totalPagesContractors,
          },
        };
        if (response?.contractor_count === 0) {
          this.openAddTemplate();
        }
      }
    });
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsContractors,
          otherParams: this.otherParamsContractors,
          selectedContractor: this.selectedContractor,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  getSubContractors(getCount = true) {
    let params: any = {};
    this.spinnerService.show();

    if (this.rowsContractors) {
      params['rows'] = this.rowsContractors;
    }
    if (this.previousContractors) {
      params['previous'] = this.previousContractors;
    }
    if (this.sortKeyContractors) {
      params['order_by'] = this.sortKeyContractors;
    }
    if (this.searchParamsContractors) {
      params['search_filters'] = JSON.stringify(this.searchParamsContractors);
    }

    if (getCount) this.getContractorsCount(params);

    this.contractorService.getContactors(params).then((response: any) => {
      if (response['status'] == 'success') {
        this.contactorsListData = response?.data;
        this.updateRoutPath();
        this.spinnerService.hide();
      } else {
        this.spinnerService.hide();
      }
    });
  }
  onChangePaginationContractor(data: any) {
    this.previousContractors = data?.paginationData?.previousRows;
    this.pageNumContractors = data?.paginationData?.pageNum;
    this.rowsContractors = data?.paginationData?.rows;

    this.otherParamsContractors.paginationData = {
      ...data?.paginationData,
      fixedRows: true,
    };
    this.getSubContractors(false);
  }
  sortColumnContractor(body: any) {
    this.sortKeyContractors = body?.sortList || [];
    this.searchParamsContractors = body?.searchParams || {};
    this.getSubContractors(false);
  }
  searchColumnContractor(event: any) {
    this.searchParamsContractors = event?.searchParams || {};
    this.pageNumContractors = 1;
    this.previousContractors = 0;
    this.getSubContractors();
  }
  onTableRowClick(event: any) {
    if (this.largeView) {
      if (this.selectedContractor?.id === event?.id) return;
      this.selectedContractor = {};
      this.spinnerService.show();
      setTimeout(() => {
        this.selectedContractor = event;
        this.updateRoutPath();
      }, 100);
    } else {
      this.router.navigate(['/view-sub-contractor', { sKey: btoa(event?.id) }]);
    }
  }

  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsContractors = {
          ...this.searchParamsContractors,
          ...(urlFragmentDetails?.searchParams || {}),
        };
        this.selectedContractor = urlFragmentDetails?.selectedContractor || {};
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousContractors =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousContractors;
          this.pageNumContractors =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumContractors;
          this.rowsContractors =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsContractors;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    let userEventDetailsTableView = [
      {
        header: 'Subcontractors',
        name: 'company_name',
        searchKey: 'company_name',
      },
    ];

    updateCustomTableHeaders(
      userEventDetailsTableView,
      this.searchParamsContractors,
    );

    this.contactorTableDetails = [...userEventDetailsTableView];
  }
  updateListData(eventData: any) {
    if (eventData?.id) {
      const itemIndex = this.contactorsListData?.findIndex(
        (item: any) => item?.id == eventData?.id,
      );

      if (itemIndex > -1) {
        this.contactorsListData[itemIndex] = {
          ...this.contactorsListData[itemIndex],
          ...eventData,
        };
      }
      this.contactorsListData = [...this.contactorsListData];
    } else {
      this.selectedContractor = {};
      this.pageNumContractors = 1;
      this.previousContractors = 0;
      this.getSubContractors();
    }
  }
}
